export enum TimelineParty {
    VetValue = 0,
    Seller = 1,
    Buyer = 2,
}

export const TimelineParties = [
    { id: TimelineParty.VetValue, name: 'VetValue' },
    { id: TimelineParty.Seller, name: 'Seller' },
    { id: TimelineParty.Buyer, name: 'Buyer' },
];

export const TimelinePartyColors = [
    {
        id: TimelineParty.VetValue,
        color: '#666630',
        backgroundColor: '#fcffa8',
        activeColor: '#fcffa8',
        activeBackgroundColor: '#808047',
    },
    {
        id: TimelineParty.Seller,
        color: '#336640',
        backgroundColor: '#a1ffaf',
        activeColor: '#a1ffaf',
        activeBackgroundColor: '#336640',
    },
    {
        id: TimelineParty.Buyer,
        color: '#664342',
        backgroundColor: '#ffaaa8',
        activeColor: '#ffaaa8',
        activeBackgroundColor: '#664342',
    },
];
